import { mountXEvent, X_Events } from '@farmersdog/pixels';

export function mountXAddToCart() {
  mountXEvent({ eventName: X_Events.Add_To_Cart });
}
